import { useSEO } from '@/hooks/useSEO';
import PageNavbar from "@/components/feature/PageNavbar";
import Footer from "@/pages/home/components/Footer";
import HvacHero from "./components/HvacHero";
import HvacOverview from "./components/HvacOverview";
import HvacProducts from "./components/HvacProducts";
import HvacProcess from "./components/HvacProcess";
import HvacGallery from "./components/HvacGallery";
import HvacInquiry from "./components/HvacInquiry";

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || 'https://isman.co.ke';

const HVAC_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "HVAC Systems Installation Kenya",
    "url": SITE_URL + "/hvac-systems",
    "description": "Professional HVAC system design, installation and maintenance in Kenya. Air conditioning, cold rooms, chillers, ventilation and building management systems by ISMAN Engineering.",
    "provider": {
      "@type": "LocalBusiness",
      "name": "ISMAN Engineering Company",
      "url": SITE_URL,
      "telephone": "+254724114555"
    },
    "areaServed": { "@type": "Country", "name": "Kenya" },
    "serviceType": "HVAC Installation & Maintenance"
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL },
      { "@type": "ListItem", "position": 2, "name": "HVAC Systems", "item": SITE_URL + "/hvac-systems" }
    ]
  }
];

export default function HvacSystemsPage() {
  useSEO({
    title: 'HVAC Systems Installation Kenya | Air Conditioning Chillers | ISMAN Nairobi',
    description: 'Professional HVAC installation and maintenance in Kenya — air conditioning, cold rooms, chillers and building management systems. Trusted by 200+ clients across Nairobi and Kenya.',
    keywords: 'HVAC installation Kenya, air conditioning Kenya, cold room installation Nairobi, chiller installation Kenya, building management system Kenya',
    canonical: SITE_URL + '/hvac-systems',
    schema: HVAC_SCHEMA,
  });

  return (
    <div className="min-h-screen">
      <PageNavbar />
      <HvacHero />
      <HvacOverview />
      <HvacProducts />
      <HvacProcess />
      <HvacGallery />
      <HvacInquiry />
      <Footer />
    </div>
  );
}
